export const PLANNING_DISCUSSIONS_FEATURE_STORAGE_KEY = 'cityscope:planning-discussions-enabled';
export const PLANNING_DISCUSSIONS_FEATURE_EVENT = 'cityscope:planning-discussions-feature-change';

type PlanningDiscussionsFeatureEventDetail = {
  enabled: true;
};

function clearLegacyDisabledValue(): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem(PLANNING_DISCUSSIONS_FEATURE_STORAGE_KEY);
  } catch {
    // Storage is non-critical; discussion remains enabled either way.
  }
}

export function isPlanningDiscussionsFeatureEnabled(): true {
  return true;
}

export function setPlanningDiscussionsFeatureEnabled(_enabled: boolean): void {
  clearLegacyDisabledValue();

  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<PlanningDiscussionsFeatureEventDetail>(PLANNING_DISCUSSIONS_FEATURE_EVENT, {
      detail: { enabled: true },
    })
  );
}

export function usePlanningDiscussionsFeatureFlag(): true {
  return true;
}
